module.exports = __webpack_public_path__ + "img/successInfo-1.986440cb.png";